import { API_PDC_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const banksConstants = {
  GET_TSPAY_BANKS_START: "GET_TSPAY_BANKS_START",
  GET_TSPAY_BANKS_SUCCESS: "GET_TSPAY_BANKS_SUCCESS",
  GET_TSPAY_BANKS_ERROR: "GET_TSPAY_BANKS_ERROR",

  GET_TSPAY_PRODUCTS_START: "GET_TSPAY_PRODUCTS_START",
  GET_TSPAY_PRODUCTS_SUCCESS: "GET_TSPAY_PRODUCTS_SUCCESS",
  GET_TSPAY_PRODUCTS_ERROR: "GET_TSPAY_PRODUCTS_ERROR"
};

export function getBanks(
  auth, accountantUuid, companyUuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: banksConstants.GET_TSPAY_BANKS_START
      });

      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/banks?itemId=${companyUuid}&managerId=${accountantUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: banksConstants.GET_TSPAY_BANKS_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: banksConstants.GET_TSPAY_BANKS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function getProducts(
  auth, accountantUuid, companyUuid, bankId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: banksConstants.GET_TSPAY_PRODUCTS_START
      });

      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/banks/${bankId}/products?managerId=${accountantUuid}&itemId=${companyUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: banksConstants.GET_TSPAY_PRODUCTS_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: banksConstants.GET_TSPAY_PRODUCTS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
